export type { IApiClient, StreamHandle } from './interface'
export { ApplicationApiClient } from './applicationClient'
export { MockApiClient } from './mockClient'
export * from './types'

import type { IApiClient } from './interface'
import { ApplicationApiClient } from './applicationClient'
import { MockApiClient } from './mockClient'
import type { ChatIntentScope } from './chatIntentJournal'

/** Factory: returns mock client when VITE_MOCK_DATA=true, otherwise live. */
export function createApiClient(
  accessToken?: string,
  chatIntentScope?: ChatIntentScope,
): IApiClient {
  if (import.meta.env.VITE_MOCK_DATA === 'true') {
    return new MockApiClient()
  }
  // Production browser traffic is same-origin and session-cookie based.
  // The argument remains accepted for source compatibility with older tests.
  void accessToken
  return new ApplicationApiClient({
    ...(chatIntentScope
      ? {
          chatIntentScope,
          chatIntentStorage: window.sessionStorage,
          pruneForeignChatIntentPartitions: true,
        }
      : {}),
  })
}
